import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  runpnl: localStorage.getItem('runpnl')
    ? JSON.parse(localStorage.getItem('runpnl'))
    : null,
};

const runpnlSlice = createSlice({
  name: 'runpnl',
  initialState,
  reducers: {
    setRunningpnl: (state, action) => {
      state.runpnl = action.payload.runpnl;
      localStorage.setItem('runpnl', JSON.stringify(action.payload.runpnl));
    },
  },
});

export const {setRunningpnl } = runpnlSlice.actions;

export default runpnlSlice.reducer;
